import { skillAliases } from '../data/skillsData';

const escapeRegExp = (text) => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Whole-word, case-insensitive: a term must not touch another letter or digit.
const wholeWord = (term) => new RegExp(`(^|[^a-z0-9])${escapeRegExp(term)}([^a-z0-9]|$)`, 'i');

export function termsFor(skill, aliases = skillAliases) {
    return aliases[skill] || [skill];
}

// Finds where a skill appears in the real experience and project text.
export function findSkillEvidence(skill, experience, projects, aliases = skillAliases) {
    const matchers = termsFor(skill, aliases).map(wholeWord);
    const mentions = (text) => Boolean(text) && matchers.some((matcher) => matcher.test(text));

    const roles = experience
        .map((job) => ({
            id: job.id,
            jobtitle: job.jobtitle,
            company: job.company,
            matches: [job.summary, ...(job.highlights || [])].filter(mentions),
        }))
        .filter((role) => role.matches.length > 0);

    const matchedProjects = projects
        .filter((project) => mentions(`${project.projectName} ${project.projectDesc} ${(project.tags || []).join(' ')}`))
        .map((project) => ({ id: project.id, name: project.projectName, tags: project.tags || [] }));

    return { roles, projects: matchedProjects };
}
